import { gql } from '@apollo/client';

export const GET_PRINT_PROVIDER_BY_ID = gql`
  query getPrintProviderById($printProviderId: String!) {
    getPrintProviderById(printProviderId: $printProviderId)
      @rest(
        method: "GET"
        type: "Get Print Provider By ID"
        path: "printprovider/{args.printProviderId}"
      ) {
      printProviderId
      isEnabled
      country
      name
      decription
      address
      phoneNumber
      email
      website
      orderingSystems {
        id
      }
      omsUsers {
        userId
      }
      omsType
      omsServiceUrl
      omsSecretKey
      drawingPrintSettings {
        defaultFormatGroup
        formatGroups {
          id
          name
          sequence
          description
          printFormats {
            id
            printScalings {
              printFormatGroup
              printFormat
              scale
            }
          }
        }
        defaultPrintOption
        printOptions {
          id
          name
          sequence
          description
        }
        defaultPostProcessingOption
        postProcessingOptions {
          id
          name
          sequence
          description
        }
      }
      documentPrintSettings {
        defaultPrintOption
        printOptions {
          id
          name
          sequence
          description
        }
        defaultPostProcessingOption
        postProcessingOptions {
          id
          name
          sequence
          description
        }
      }
      deliveryOptions {
        standardDeliveryMinDays
        standardDeliveryMaxDays
        expressDeliveryMinHours
        expressDeliveryEnabled
      }
      isOrgIdRequired
      language
      emailForOrders
    }
  }
`;
